import StarLoader from './StarLoader';

export default StarLoader;
